/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown>, amount: NonNullable<unknown>, cap: NonNullable<unknown> }} Usage_Overage_Alert_At_AmountInputs */



/**
* | output |
* | --- |
* | "Email at {pct}% ({amount} of {cap})" |
*
* @param {Usage_Overage_Alert_At_AmountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_alert_at_amount = /** @type {((inputs: Usage_Overage_Alert_At_AmountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Alert_At_AmountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`E-Mail bei ${i?.pct} % (${i?.amount} von ${i?.cap})`)
	return /** @type {LocalizedString} */ (`Email at ${i?.pct}% (${i?.amount} of ${i?.cap})`)
});